
export default {
  props: {
    src: {
      type: String,
      required: true
    },
    size: {
      type: String,
      default: '2.4rem'
    },
    failedIcon: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      failed: false
    }
  },
  methods: {
    onFail() {
      this.failed = true
    }
  }
}
